<template>
    <div>
        <!-- Header section -->
        <div class="d-flex align-items-center w-100 px-4 flex-column flex-md-row">
            <CoHeadline :level="3" class="mb">
                {{ $t('labels.plannew') }}
            </CoHeadline>
            <div class="ml-auto d-flex align-items-center justify-content-center flex-shrink-0">
                <CoButton
                    class="flex-shrink-0 mr-2 text-muted"
                    type="text"
                    @click="hasHistory() ? $router.go(-1) : $router.push('/admin/monetization/plan')"
                    :label="$t('labels.cancel')"
                ></CoButton>
                <CoButton
                    class="flex-shrink-0"
                    variant="primary"
                    @click="create()"
                    :disabled="clicked"
                    :label="$t('labels.create')"
                ></CoButton>
            </div>
        </div>
        <CoPlanEdit
            :plan="form"
            :is-with-section-padding="true"
            :is-with-custom-sign-button="true"
            :tax-rates="taxRates"
            :selected-extras="selectedExtras"
            :upgrades="allExtras"
            :resources="resources"
        />
    </div>
</template>
<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>
<script>
import axios from 'axios';
import Vue from 'vue';
import EventBus from '@/eventBus';
import CoPlanEdit from '@/components/Organisms/co-plan-edit/CoPlanEdit.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';

export default {
    name: 'CreatePlan',
    components: { CoPlanEdit, CoButton, CoHeadline },
    data() {
        return {
            loading: false,
            form: {
                CancelationNotice: 0,
                Currency: 'EUR',
                TaxRateID: null,
                TimeInteval: 0,
                IntervalCount: 1,
                Active: true,
            },

            taxRates: [],

            clicked: false,

            // data for resources
            resources: [],

            // data for extras
            allExtras: [],
            selectedExtras: [],
        };
    },
    created() {
        const { ID } = this.$route.params;
        if (this.$store.state.space.Currency) {
            this.form.Currency = this.$store.state.space.Currency;
        }

        this.listAllExtras();
        this.getTaxRates();
        this.getResources();
    },
    methods: {
        hasHistory() {
            return window.history.length > 2;
        },

        listAllExtras() {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/extra/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.allExtras = response.data.Extras;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },

        create() {
            this.clicked = true;
            this.loading = true;
            if (this.form.ImageURL) {
                this.image = this.form.ImageURL;
            }
            if (this.image) {
                this.uploadImages(this.postPlan);
            } else {
                this.postPlan();
            }
        },

        uploadImages(callback) {
            const infoMsg = {
                Message: this.$t('messages.uploadingimages'),
                Details: null,
            };
            EventBus.$emit('INFO', infoMsg);

            this.$store
                .dispatch('imageUpload', {
                    file: this.image,
                    url: '/upload/image/plans',
                })
                .then((response) => {
                    this.form.ImageURL = response;
                    callback();
                })
                .catch((error) => {
                    console.log(error);
                    const errorMsg = {
                        Message: this.$t('messages.imageUploadFailed'),
                        Details: '',
                    };
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message === 'Request Entity Too Large'
                    ) {
                        errorMsg.Message = this.$t('messages.fileTooLarge', { size: '10 MB' });
                    }
                    EventBus.$emit('ERROR', errorMsg);
                });
        },

        postPlan() {
            const object = this.form;
            if (this.form.TaxRate && this.form.TaxRate.Value) {
                object.TaxRateID = this.form.TaxRate.Value.ID;
                object.TaxRate = null;
            }

            axios({
                method: 'POST',
                url: '/admin/plan/create',
                data: object,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.planCreated'),
                        Details: '',
                    });
                    this.form = response;
                    this.loading = false;
                    this.$router.push(`/admin/monetization/plan/${response.data.ID}`);
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.planCreateFailed'),
                        Details: error,
                    });
                    this.loading = false;
                    this.clicked = false;
                });

            this.loading = false;
        },

        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/admin/tax-rate/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    console.log(error);
                });
        },
        getResources() {
            // get all resources available for in space
            this.loadingResources = true;
            axios({
                method: 'GET',
                url: '/admin/booking/resource/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // Keep an empty first-use response from leaving stale resource options behind.
                    this.resources =
                        response.data && Array.isArray(response.data.Resources) ? response.data.Resources : [];
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingResources = false;
                });
        },
    },
};
</script>
